//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Option',
  props: ['option'],
  data: function () {
    return {
      isActive: this.option.isActive,
      counter: this.option.counter ? this.option.counter : 1,
    }
  },

  computed: {
    price() {
      if (this.option.price < 1) {
        return 'wliczone w cenę'
      } else if (!this.option.countable) {
        return `${this.option.price} PLN`
      } else {
        return `${this.option.price} PLN/${this.option.countable}`
      }
    },
    optionClass() {
      return this.isActive ? 'config-option config-option--active' : 'config-option'
    }
  },

  methods: {
    handleClick() {
      this.isActive = !this.isActive
      this.sendEventInfo()
    },
    sendEventInfo() {
      let choiceOption = {
        id: this.option.id,
        category: this.option.category,
        counter: this.counter,
        active: this.isActive,
        details: this.option,
      }

      this.$emit('updatedChoice', choiceOption)
    },
    increaseCounter() {
      let count = this.counter
      this.counter = ((this.counter + 1 <= this.option.max) ? this.counter + 1 : this.counter)
      this.sendEventInfo()
    },
    decreaseCounter() {
      let count = this.counter
      this.counter = ((this.counter - 1 >= 1) ? this.counter - 1 : this.counter)
      this.sendEventInfo()
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/vue/partials/ConfigOption.vue